import { createFeatureSelector, createSelector } from '@ngrx/store';

import { APP_FEATURE_KEY, AppState } from './app.reducer';

// Lookup the 'App' feature state managed by NgRx
export const selectAppState = createFeatureSelector<AppState>(APP_FEATURE_KEY);

export const isAppLoaded = createSelector(selectAppState, (state: AppState) => state.loaded);

export const getAppError = createSelector(selectAppState, (state: AppState) => state.error);

export const getAppSettings = createSelector(selectAppState, (state: AppState) => state.settings);

export const getHelpState = createSelector(selectAppState, (state: AppState) => state.helpOpen);
